export default "__VITE_ASSET__DU1nb0ZY__"